// extracted by mini-css-extract-plugin
export var button = "_95-0";
export var icon = "_95-1";